'use client'

import { useEffect, useState } from 'react'

export default function ShareX({
  children,
  url,
  title,
  className,
}: {
  children?: React.ReactNode
  url?: string
  title?: string
  className?: string
}) {
  const [shareUrl, setShareUrl] = useState<string>(url || '')

  useEffect(() => {
    if (!shareUrl) {
      const currentUrl = window.location.href
      setShareUrl(currentUrl)
    }
  }, [shareUrl])

  return (
    <a
      href={`https://x.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title || '')}&hashtags=Hougarden`}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
      aria-label='Share on X'
    >
      {children}
    </a>
  )
}
